// START A/B TEST PLOCTOPLUS-2679: Resume Subscription CTA
import { Tooltip, TooltipConfig } from 'components/Tooltip';
import { getLocale } from 'services/LocalizationService';

export class ResumeCTATopNav {
    constructor() {
        this.init();
    }

    init() {
        try {
            if (this.isLocationHomeORBrowse()) {
                // setup tooltip and tracking
                this.setupCtaTooltip();
                this.setupTrackingEvents();
            }
        } catch (e) {
            console.error('Error in ResumeCTATopNav', e);
        }
    }

    /**
     * Setup tooltip on resume subscription cta
     */
    setupCtaTooltip() {
        const tooltipConfig = new TooltipConfig({
            targetSelector: '.resumeSubscriptionCTA',
            selectorsList: ['.resumeSubscriptionCTA'],
            innerHTML: getLocale(
                'your_subscription_is_set_to_end_soon_resume_now_to_keep_your_access',
            ),
            events: ['mouseover', 'focus'],
            position: 'bottom',
            hideOnScroll: true,
        });
        new Tooltip(tooltipConfig);
    }

    isLocationHomeORBrowse() {
        return window.location.pathname === '/home/' || window.location.pathname === '/browse/';
    }

    /**
     * Setup/bind cta mouseover and click events to tracking functions
     */
    setupTrackingEvents() {
        const elements = document.getElementsByClassName('resumeSubscriptionCTA');

        if (elements.length > 0) {
            const cta = elements[0];
            cta.addEventListener('mouseover', this.trackCtaMouseover);
            cta.addEventListener('click', this.trackCtaClick);
        }
    }

    /**
     * Tracking for resume subscription cta click event
     */
    trackCtaClick() {
        const trackingParams = {
            menuItemLabel: 'Resume subscription',
            menuOrientation: 'header',
            posRowNum: '0',
            posColNum: '9',
        };
        if (typeof om != 'undefined') {
            om.trackAction('trackMenu', trackingParams);
        }
    }

    /**
     * Tracking for resume subscription cta mouse over event
     */
    trackCtaMouseover() {
        const trackingParams = {
            tooltipType: 'resume subscription',
        };

        if (typeof om != 'undefined') {
            om.trackAction('trackTooltipView', trackingParams);
        }
    }
}
// END A/B TEST PLOCTOPLUS-2679: Resume Subscription CTA
